import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import NewExternalJobBoardForm from './NewExternalJobBoardForm';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';

const NewExternalJobBoardModal = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { closeNewExternalJobBoardModal } = useBiopharmaGroupActions();

  return (
    <StandardModal
      isOpen={biopharmaGroupState?.newExternalJobBoardModalIsOpen}
      contentLabel={'Add New External Job Board'}
      onRequestClose={() => {
        closeNewExternalJobBoardModal();
      }}
    >
      <PageTitle text={'New External Job Board'} />
      <NewExternalJobBoardForm />
    </StandardModal>
  );
};

export default NewExternalJobBoardModal;